import Store from 'repatch';

import State from '../core/State';
import MessageDispatcher from '../service/MessageDispatcher';
import ProjectWebApi from '../service/persistent/ProjectWebApi';
import { decrement, increment } from '../thunk/fullScreenSpinner';
import { finishFetchingProjects, setProjects, startFetchingProjects } from '../thunk/projects';

class DeleteProjectUsecase {
  private readonly store: Store<State>;
  private readonly messageDispatcher: MessageDispatcher;
  private projectWebApi: ProjectWebApi;

  constructor({
    store,
    messageDispatcher,
    projectWebApi,
  }: {
    store: Store<State>;
    messageDispatcher: MessageDispatcher;
    projectWebApi: ProjectWebApi;
  }) {
    this.store = store;
    this.messageDispatcher = messageDispatcher;
    this.projectWebApi = projectWebApi;
  }

  public deleteDraftProject = async (project: { id: string }): Promise<void> => {
    const projects = this.store.getState().projects;

    this.store.dispatch(increment());

    try {
      await this.projectWebApi.deleteDraftProject(project);
    } catch (err) {
      this.store.dispatch(decrement());

      this.messageDispatcher.notifyUnimportant('message.deleting_project_has_failed');

      return;
    }

    const removedDraftProjects = projects.draft.items.filter((pj) => pj.id !== project.id);
    this.store.dispatch(startFetchingProjects('draft'));
    this.store.dispatch(setProjects('draft', removedDraftProjects, projects.draft.pageInfo));
    this.store.dispatch(finishFetchingProjects('draft'));
    this.store.dispatch(decrement());
    this.messageDispatcher.notifyUnimportant('message.project_has_been_deleted');
  };
}

export default DeleteProjectUsecase;
